const getDate = (): string => Date();
const generateMsg = (msg: string, ...args: any[]) => (args && args.length ? `${getDate()} - ${msg}: ` : `${getDate()} - ${msg}`);

export const consoleLog = (msg: string, ...args: any[]) => console.log(generateMsg(msg, ...args), ...args);
export const consoleWarn = (msg: string, ...args: any[]) => console.warn(generateMsg(msg, ...args), ...args);
export const consoleError = (msg: string, ...args: any[]) => console.error(generateMsg(msg, ...args), ...args);
